import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpXsrfInterceptor } from 'src/app/http-interceptors/xrsf-interceptor';

import { ErrorInterceptor } from 'src/app/http-interceptors/error-interceptor';
import { ApiInterceptor } from 'src/app/http-interceptors/api-interceptor';
import { AuthService } from 'src/app/services/auth.service';

// modules
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportingSystemRoutingModule } from './reporting-system-routing.module';

import { ReportingSystemComponent } from './reporting-system.component';
import { EisHeaderComponent } from './components/header/eis-header.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { HomeComponent } from './components/home/home.component';
import { GenerateReportsComponent } from './components/generate-reports/generate-reports.component';
import { LoginComponent } from './components/login/login.component';
import { UsersComponent } from './components/users/users.component';

const materialModules = [
  MatDatepickerModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatInputModule,
  MatIconModule,
  MatMenuModule,
];

@NgModule({
    declarations: [ReportingSystemComponent],
    imports: [
    ReportingSystemRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    ...materialModules,
    DatePickerComponent,
    EisHeaderComponent,
    GenerateReportsComponent,
    LoginComponent,
    HomeComponent,
    UsersComponent,
],
    exports: [],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpXsrfInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (auth: AuthService) => () => auth.checkReturningUser(),
            deps: [AuthService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
    ],
    bootstrap: [ReportingSystemComponent],
})
export class ReportingSystemModule {}
